export default __webpack_public_path__ + "548d1f7c56d5cf0a7dae39231b647bf7.jpg";